<template>
  <div class="yx-assitant-page main-layout">
    <el-card class="box-inner box-bg1">
      <c-title slot="header" title="我的宿舍" :back="false"></c-title>
      <div class="div-scroll" style="width: 60%; margin: 0 auto">
        <el-row class="avatar-row" v-if="JSON.stringify(dormitoryInfo) != '{}'">
          <el-col :span="24">
            <c-des
              :span="1"
              :desItems="formItems"
              :value="dormitoryInfo"
              :column="1"
              :labelStyle="{ width: '120px' }"
            >
            </c-des>
          </el-col>
        </el-row>

        <empty v-else />
      </div>
    </el-card>
  </div>
</template>

<script>
import Configs from "./data/dormitory.js";
import Empty from "@/components/Empty/index";
export default {
  name: "",
  components: {
    Empty,
  },
  data() {
    let { formItems } = Configs(this);
    return {
      formItems,
      SUCCESS_CODE: "",
      dormitoryInfo: {},
      isLoading: true,
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.getDormitoryInfo();
  },
  mounted() {},
  methods: {
    // 获取学生宿舍信息
    getDormitoryInfo() {
      this.isLoading = true;
      this.$http
        .get("/dormitory-accommodation/dormitory/student/bed/myInfo")
        .then((res) => {
          // console.log(res)
          if (res.code == this.SUCCESS_CODE) {
            if (res.data) {
              this.disabled = false;
              this.dormitoryInfo = res.data;
            }
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          // Toast.fail(`获取详情失败，${err}`);
        });
    },
  },
};
</script>
